import Vue from 'vue'
import VueTransmit from "vue-transmit"
Vue.use(VueTransmit)
/**
 * Плагин для drag and drop загрузки файлов
 * https://github.com/alexsasharegan/vue-transmit
 */
